<template>
    <div class="erron_contain">
       <img src="https://p1.fishqc.net/FjUbwN-I2G4c0_rahTNpzVfy4Wm0" alt="" class="error_img">
    </div>
</template>
<script>
import {myMixin} from '@/mixin/mixin.js'
export default {
    name: 'error',
    components: {

    },
    mixins:[myMixin],
    data() {
        return {
          
        }
    },
    created() {
        this.footerAuto('erron_contain')
    },

    methods: {
       
        
    }

}
</script>
<style scoped>
    .erron_contain{
        padding: 100px 0 0;
        box-sizing: border-box;
    }
    .error_img{
        height: 350px;
        width: auto;
        margin: 100px auto 0;
    }
</style>